import { FetchCurrentQuery } from 'generated/graphql';
import { USER_FEATURE_FLAG } from 'types/featureFlag';

//This hooks is being used to check lea user roles for now. Can be edit if needed for more userRoles.
export const useUserRoles = (data: FetchCurrentQuery | undefined) => {
  const userFeatureFlags = data?.current?.userFeatureFlags || [];

  const isUserLeaManager = userFeatureFlags.includes(USER_FEATURE_FLAG.ALLOW_USER_MANAGE_LEA);
  const isUserBDR = userFeatureFlags.includes(
    USER_FEATURE_FLAG.ALLOW_USER_TO_CREATE_OR_EDIT_LEA_QUESTIONNAIRE
  );

  const filteredRoles = userFeatureFlags.filter(
    (role) =>
      role !== USER_FEATURE_FLAG.ALLOW_USER_MANAGE_LEA &&
      role !== USER_FEATURE_FLAG.ALLOW_USER_TO_CREATE_OR_EDIT_LEA_QUESTIONNAIRE &&
      role !== USER_FEATURE_FLAG.CUSTOMERS &&
      role !== USER_FEATURE_FLAG.ALLOW_CREATE_HUB &&
      role !== USER_FEATURE_FLAG.ALLOW_EDIT_HUB
  );

  const isOnlyLeaOrBdr = (isUserBDR || isUserLeaManager) && !filteredRoles.length;

  return { isUserLeaManager, isUserBDR, filteredRoles, isOnlyLeaOrBdr };
};
